import { Component, OnInit } from "@angular/core";
import { FileInfo } from "../../../shared/models/classes/file/file-info";
import { ProviderCode } from "../../../shared/models/enums/provider-code.enum";
import { FileService } from "../../../shared/services/file.service";
import { MatCheckboxChange } from '@angular/material/checkbox';
import { environment } from "@environments/environment";
import { AuthService } from "@services/auth.service";

@Component({
    selector: "app-upload-bizzdev",
    templateUrl: "./upload-bizzdev.component.html",
    styleUrls: ["./upload-bizzdev.component.scss"],
})
export class UploadBizzdevComponent implements OnInit {
    providerType: any;
    provider: string = 'sic';
    folder: string = 'article';
    sicFolders: any;
    sicbxlFolders: any;
    bbcFolders: any;

    canImport = false;
    isEnabledImport = false;
    isDisabled = true;

    constructor(
        private authSrv: AuthService,
        private fileSrv: FileService
    ) {}

    ngOnInit(): void {
        const role = this.authSrv.getAuthUser().role;
        this.isDisabled = environment.name !== 'dev' && role !== 'bizzdev';

        this.initProviderEnum();
        this.initFolders();

        this.fileSrv.isEnabledJobImport().subscribe(isEnabled =>
        {
            this.canImport       = true     ;
            this.isEnabledImport = isEnabled;
        });
    }
    moveFilesToDestPath(filesInfo: FileInfo[]): void {
        this.fileSrv
            .importSystem(filesInfo, this.provider, this.folder)
            .subscribe();
    }
    initFolders() {
        this.fileSrv
            .getFolders("sic")
            .subscribe((value) => (this.sicFolders = value));
        this.fileSrv
            .getFolders("sicbxl")
            .subscribe((value) => (this.sicbxlFolders = value));
        this.fileSrv
            .getFolders("bbc2020")
            .subscribe((value) => (this.bbcFolders = value));
    }
    initProviderEnum() {
        this.providerType = Object.values(ProviderCode);
    }

    isEnabledImportChanged(event: MatCheckboxChange) {
        this.fileSrv.setIsEnabledJobImport(event.checked).subscribe();
    }

    onProviderChange() : void {
        if (this.provider === 'sic')
            this.folder = 'article';
    }
}
